import { render, staticRenderFns } from "./solve.vue?vue&type=template&id=0ea733c6&scoped=true"
import script from "./solve.vue?vue&type=script&lang=js"
export * from "./solve.vue?vue&type=script&lang=js"
import style0 from "./solve.vue?vue&type=style&index=0&id=0ea733c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea733c6",
  null
  
)

export default component.exports